import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Checkbox, TableSortLabel } from '@material-ui/core';
import CheckedIcon from 'material-ui/svg-icons/toggle/check-box';
import CheckBoxOutlineBlankIcon from "material-ui/svg-icons/toggle/check-box-outline-blank";


const styles = theme => ({
  
    root: {
        width: '122.5rem',
        marginTop: theme.spacing.unit * 3,
        marginTop:'1rem',
        // overflowX: 'auto',
        fontFamily: 'Roboto Medium'
    },
    table: {
        minWidth: '110rem',
        width:'124rem'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
        paddingLeft:'0px !important'
    },
    headerCell: {
        color: '#474747',
        fontFamily: 'Roboto',
        fontSize: '12px ',
        width: '13rem',
        padding: '0px'
    },
    cell: {
        fontSize: '1.2rem',
        fontWeight: '600',
        color: '#000000',
        fontFamily: 'Roboto',
    }
});

function desc(a, b, orderBy) {
    const aVal = a[orderBy] || '';
    const bVal = b[orderBy] || '';
    if (bVal < aVal) {
        return -1;
    }
    if (bVal > aVal) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

class DataTable extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedRows: [],
            headers: props.headers,
            sortOrder: 'asc',
            sortBy: ''
        }
    }

    componentWillReceiveProps = (props) => {

        if(props.selectedRows) {

            this.setState({
                selectedRows : props.selectedRows
            })    
        }    
        if(props.sortOrder) {

            this.setState({
                selectedRows : props.selectedRows
            })  
            this.setState({
                sortOrder:'desc'
            })  
        }          
    }
    handleCheck = (data, flag) => {
        let { selectedRows } = this.state;
       
        if (flag && flag === 'all') {
            if (this.props.rows.length > 0 && selectedRows.length === this.props.rows.length) {
                selectedRows = [];
            } else {
                selectedRows = [...data];
            }
        } else {
            
            const index = selectedRows.indexOf(data);
            if (index > -1) {
               
                selectedRows.splice(index, 1);
              
            } else {
                selectedRows.push(data);
            }
           
        }
        this.setState({ selectedRows });
        this.props.onCheck(selectedRows);
    }
    routeChange = () => {
        //consolelog('routechanged');
    }
    handleSort = header => {
        let { sortOrder, sortBy } = this.state;

        sortOrder = sortBy != header.id || sortOrder === 'asc' ? 'desc' : 'asc';
        sortBy = header.id;
        this.setState({ sortOrder, sortBy });
      //  //consolelog('sortyBy : ', sortBy, 'Sort Order : ', sortOrder)
    }

    render() {

        const { classes, showCheckBox, showCheckBoxAll, headers, rows, styles } = this.props;
       // //consolelog('rows',rows);
        const { selectedRows, sortBy, sortOrder } = this.state;
       // //consolelog('rows',classes.root);
        const numSelected = selectedRows.length, rowCount = rows.length;

        if (!headers || headers.length === 0) {
            return '';
        }
        let rowKey = headers[0].id;
        return (<Paper className={classes.root}  style = {styles?{paddingLeft:'20px'
        ,paddingRight:'20px',...styles.table||styles.root}:{}} >
            <Table className={classes.table} style = {styles?styles.root:{}}>
                <colgroup>
                    {/* {showCheckBox && <col style={{ width: '5%' }} />} */}
                    {headers.map((each, index) => <col key={`col-${index}`} style={each.style} />)}
                </colgroup>
                <TableHead >
                    <TableRow style = {styles?styles.thead:{}}>
                        {/* {showCheckBox && <TableCell padding="checkbox" colSpan="1"  style = {styles?styles.headerCell:{}}>
                            {showCheckBoxAll && <Checkbox
                             style={{ width: 20, height: 20 }}
                                indeterminate={numSelected > 0 && numSelected < rowCount}
                                checked={rowCount > 0 && numSelected === rowCount}
                                onChange={e => this.handleCheck(rows, 'all')}
                                icon = {<CheckBoxOutlineBlankIcon style={{height:'15px',width:'15px',border: '1px solid #858585',
                                            borderRadius: '2px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'}}/>}
                                checkedIcon={<CheckedIcon style={{fill: "red"}}/>}
                            />}
                        </TableCell>} */}
                        
                        {
                        
                        headers.map((each,index) => <TableCell
                            key={each.label}
                            colSpan={each.colSpan}
                            className={classes.headerCell}
                            sortDirection={each.sortEnabled ? sortOrder : false}
                            style = {styles?styles.headerCell:{}}
                        >
                              {showCheckBox && showCheckBoxAll && index ==0&& <Checkbox
                             style={{ width: 20, height: 20 }}
                                indeterminate={numSelected > 0 && numSelected < rowCount}
                                checked={rowCount > 0 && numSelected === rowCount}
                                onChange={e => this.handleCheck(rows, 'all')}
                                icon = {<CheckBoxOutlineBlankIcon style={{height:'15px',width:'15px',border: '1px solid #858585',
                                            borderRadius: '2px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'}}/>}
                                checkedIcon={<CheckedIcon style={{fill: "red"}}/>}
                            />}
                            <TableSortLabel data-e2e={each.label}
                                active={each.sortEnabled}
                                direction={sortBy === each.id ? sortOrder : 'asc'}
                                onClick={e => { each.sortEnabled?each.handleSort(e,each.id):'', each.sortEnabled?this.handleSort(each):'' }}
                            >
                                {each.label}
                            </TableSortLabel>
                        </TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows && rows.length > 0 &&
                        rows.map(row => {
                               // //consolelog('row',row);
                                return (
                                    <TableRow key={row[rowKey] } style = {styles?styles.tbody:{}} data-e2e={row[rowKey]}>
                                        {/* {showCheckBox && <TableCell colSpan="1" padding="checkbox">
                                            <Checkbox 
                                            icon = {<CheckBoxOutlineBlankIcon style={{height:'15px',width:'15px',border: '1px solid #858585',
                                            borderRadius: '2px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'}}/>}
                                            style={{ width: 20, height: 20 }}
                                                onChange={e => this.handleCheck(row)}
                                                checked={selectedRows.indexOf(row) > -1}
                                                checkedIcon={<CheckedIcon style={{fill: "red"}}/>}
                                            />
                                        </TableCell>} */}
                                {headers.map((eachHeader, index) =>{ return(<TableCell key={row[eachHeader.id] + '-' + index} colSpan={eachHeader.colSpan} className={classes.cell}   style = {styles?{...styles.cell,'cursor':eachHeader.onClick?'pointer':'default'}:{}} >  {showCheckBox && index ===0 &&<Checkbox data-e2e={row[eachHeader.id]+"checkbox"}
                                            icon = {<CheckBoxOutlineBlankIcon style={{height:'15px',width:'15px',border: '1px solid #858585',
                                            borderRadius: '2px',
                                            backgroundColor: '#FFFFFF',
                                            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'}}/>}
                                            style={{ width: 20, height: 20 }}
                                                onChange={e => this.handleCheck(row)}
                                                checked={selectedRows.indexOf(row) > -1}
                                                checkedIcon={<CheckedIcon style={{fill: "red"}}/>}
                                            /> }<span data-e2e={row[eachHeader.id]} style={index>0 ? {fontFamily:'Roboto',fontWeight:'500',paddingLeft:'15px'}:{paddingLeft:'15px'}} onClick={e =>{eachHeader.onClick?eachHeader.onClick(e, row,row[rowKey]):''}}>{row[eachHeader.id] } {eachHeader.statsVisibleIcon?row['statsVisibleIcon']:'' }</span>{eachHeader.componentDetails&&eachHeader.componentDetails.status && eachHeader.componentDetails.index ===row[rowKey]?eachHeader.componentDetails.component:''} </TableCell>)})}
                                    </TableRow>
                                );
                            })}
                </TableBody>
            </Table>
        </Paper>)
    }
}

export default withStyles(styles)(DataTable);


/** WEBPACK FOOTER **
 ** ./src/components/common/Table/index.js
 **/